import i18n from '@/plugins/i18n'

export const reports=[
    {
        value: '1',
        text: i18n.t('registrar_report'),
        permission: 'studentreport_registrarreport'
    },
     {
       value: '2',
       text: i18n.t('ie_reporting'),
       permission: 'studentreport_iereporting'
   },
    {
        value: '3',
        text: i18n.t('financial_registration_by_Agency'),
        permission: 'studentreport_financialreport'
    },
    {
        value: '4',
        text: i18n.t('dso_registration_report'),
        permission: 'studentreport_dsoregistrationreport'
    },
]
